import './TeamAvatar.css'

const TeamAvatar = ({name, role, photo}) => {
    return (
        <>

            <div className={"row"}>
                <div className={"col-md-5 col-lg-5 col-xs-12 col-sm-12"}>
                    <div className={"avatar-img"}>
                        <img src={photo} alt={name} className="modal-member-image" />
                    </div>
                </div>
                <div className={"col-md-6 col-lg-6 col-xs-12 col-sm-12"}>
                    <div className={"team-avatar-detail"}>
                        <h2 className={"team-name"}>{name}</h2>
                        <h3 className={"team-role"}>{role}</h3>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TeamAvatar;
